module.exports = __webpack_public_path__ + "img/718c098.jpg";